"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoPublishOptions = void 0;
class AutoPublishOptions {
    constructor(data) {
        this.activated = false;
        this.emails = [];
        if (data) {
            data = (typeof data === "string") ? JSON.parse(data) : data;
            this.emails = data.emails;
            this.activated = AutoPublishOptions.toBoolOrNull(data.activated);
        }
    }
    static toBoolOrNull(value) {
        if (value === null) {
            return null;
        }
        switch (`${value}`.toLowerCase().trim()) {
            case "true":
            case "yes":
            case "1": return true;
            case "false":
            case "no":
            case "0":
            case null: return false;
            default: return Boolean(value);
        }
    }
}
exports.AutoPublishOptions = AutoPublishOptions;
//# sourceMappingURL=AutoPublishOptions.js.map